<template>
    <div>
        <span class="instruction">Please choose one or more criteria</span>

        <carousel-icons :icons="bodyStyles" :type="'body'" v-model="selectedBodies" :vhtype="type"></carousel-icons>

        <div class="row">
            <div class="col">
                <hr>
                <p class="instruction">Please choose your options below</p>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-lg">
                <div class="form-group">
                    <label class="form-label" for="fuel-type">Fuel Type</label>
                    <div class="pretty-select">
                        <select id="fuel-type" v-model="fuelType">
                            <option :value="null">All</option>
                            <option v-for="fType in fuelTypes" :key="fType.value"
                                    :value="fType.value">{{ fType.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg">
                <slider v-model="co2" :data="co2Data" prefix="" block-label="CO<sub>2</sub> (g/km)"></slider>
            </div>
        </div>

        <div class="m-5"></div>

        <div class="row">
            <div class="col-12 col-lg"  v-if="!presetManufacturer">
                <div class="form-group">
                    <label class="form-label" for="manufacturer">Manufacturer</label>
                    <div class="pretty-select">
                        <select id="manufacturer" v-model="manufacturer">
                            <option :value="null" v-if="manufacturers === null || manufacturers.length > 1">All</option>
                            <option v-for="man in manufacturers" :value="man.id" :key="man.id"
                                    :readonly="manufacturers.length === 1" :disabled="manufacturers.length === 1">{{man.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg">
                <slider v-model="rental" :data="rentalData" prefix="£" block-label="Monthly Rental"></slider>
            </div>
        </div>

        <div class="m-5"></div>

        <transition-expand>
            <carousel-range :ranges="rangeList" v-model="selectedRanges" :vhtype="type"></carousel-range>
        </transition-expand>
    </div>
</template>

<script>
    import CarouselIcons from "./CarouselIcons";
    import Slider from "./Slider";
    import {
        FILTER_BODY,
        FILTER_CO2, FILTER_DATA_MODEL,
        FILTER_FUEL_TYPE,
        FILTER_MANUFACTURER, FILTER_MODEL,
        FILTER_RENTAL
    } from "../../store/mutation-types";
    import {GET_RANGES} from "../../store/action-types";
    import CarouselRange from "./CarouselRange";
    import TransitionExpand from "../TransitionExpand";
    export default {
        name: "FilterVans",
        components: {TransitionExpand, CarouselRange, Slider, CarouselIcons},
        data: function() {
            return {
                type: 'LCV',
                icons: [
                    {
                        id:1,
                        title:"Help with improving your fleet efficiency",
                        image:"account-management.svg",
                        url: "",
                    },
                    {
                        id:2,
                        title:"A single contract releases you to focus on your core business",
                        image:"my-fleet-pro.svg",
                        url: "",
                    },
                    {
                        id:3,
                        title:"No additional admin charges as your fleet grows",
                        image:"daily-rental.svg",
                        url: "",
                    },
                    {
                        id:4,
                        title:"No additional admin charges as your fleet grows",
                        image:"daily-rental.svg",
                        url: "",
                    },
                    {
                        id:5,
                        title:"No additional admin charges as your fleet grows",
                        image:"daily-rental.svg",
                        url: "",
                    },
                    {
                        id:6,
                        title:"No additional admin charges as your fleet grows",
                        image:"daily-rental.svg",
                        url: "",
                    },
                    {
                        id:7,
                        title:"No additional admin charges as your fleet grows",
                        image:"daily-rental.svg",
                        url: "",
                    },
                ],
                co2Data: this.$store.state.LCV_CO2_VALUES,
                rentalData: this.$store.state.LCV_RENTAL_VALUES,
            }
        },
        computed:{
            manufacturer: {
                get: function() {
                    return this.$store.state.FILTER_MANUFACTURER;
                },
                set: function (value) {
                    this.$store.commit(FILTER_MANUFACTURER, value);
                }
            },
            fuelType: {
                get: function() {
                    return this.$store.state.FILTER_FUEL_TYPE;
                },
                set: function (value) {
                    this.$store.commit(FILTER_FUEL_TYPE, value);
                }
            },
            co2: {
                get: function() {
                    return this.$store.state.FILTER_CO2;
                },
                set: function (value) {
                    this.$store.commit(FILTER_CO2, value);
                }
            },
            rental: {
                get: function() {
                    return this.$store.state.FILTER_RENTAL;
                },
                set: function (value) {
                    this.$store.commit(FILTER_RENTAL, value);
                }
            },
            bodyStyles: function(){
                return this.$store.getters.bodyStyles(this.type);
            },
            selectedBodies: {
                get: function() {
                    return this.$store.state.FILTER_BODY;
                },
                set: function(value) {
                    this.$store.commit(FILTER_BODY, value);
                }
            },
            selectedRanges: {
                get: function() {
                    return this.$store.state.FILTER_MODEL;
                },
                set: function(value) {
                    this.$store.commit(FILTER_MODEL, value);
                }
            },
            manufacturers: function(){
                return this.$store.state.FILTER_DATA_MANUFACTURER;
            },
            presetManufacturer: function(){
                return this.$store.state.PRESET_MANUFACTURER;
            },
            fuelTypes: function() {
                let fuels = [
                    {name: 'Electric', value: 'Electric LCV'},
                    {name: 'Hybrid', value: 'Petrol/PlugIn Elec Hybrid'},
                    {name: 'Diesel', value: 'Diesel LCV'},
                    {name: 'Petrol', value: 'Petrol LCV'},
                ];

                return fuels;
                // no longer API based
                //return this.$store.state.FILTER_DATA_FUEL_TYPES;
            },
            rangeList: function() {
                return this.$store.state.FILTER_DATA_MODEL;
            }
        },
        methods: {
            initializeSliders: function () {
                this.co2 = [this.co2Data[0], [...this.co2Data].pop()];
                this.rental = [this.rentalData[0], [...this.rentalData].pop()];
            }
        },
        filters: {
            cleanFuelType(value) {
                return value.replace(' CAR', '').replace(' LCV', '');
            }
        },
        watch: {
            manufacturer: function(value) {
                this.$store.commit(FILTER_DATA_MODEL, []);
                if (value !== null) {
                    this.$store.dispatch(GET_RANGES);
                }
            },
            selectedBodies: function() {
                if (this.manufacturer !== null) {
                    this.$store.commit(FILTER_DATA_MODEL, []);
                    this.$store.dispatch(GET_RANGES);
                }
            }
        },
        mounted() {
            if (this.$store.state.STATE === 0) {
                this.initializeSliders()
            }
        }
    }
</script>

<style scoped lang="stylus">

</style>